module.exports = __webpack_public_path__ + "static/media/a2.b984b4f8.jpg";